<template>
  <div class="text-block" :class="{ 'text-block--border-top': borderTop }">
    <content
      class="text-block__content"
      :class="['text-block__content--' + width]"
    >
      <slot />
    </content>
  </div>
</template>

<script>
export default {
  name: 'TextBlock',
  props: {
    width: {
      type: String,
      default: 'default'
    },
    borderTop: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.text-block {
  margin-top: rem(50px);

  &__content {
    display: block;
    color: $gray-700;
    line-height: 1.75;

    &--medium {
      width: 75%;
    }

    @include media-breakpoint-down(md) {
      width: 100% !important;
    }
  }

  &--border-top {
    padding-top: rem(50px);
    border-top: 1px solid $border-color;
  }

  h3 {
    color: $gray-900;
    font-size: rem(40px);
    margin-bottom: 1rem;

    &.fs24 {
      font-size: rem(24px);
    }
  }

  h4 {
    color: $gray-900;
    margin-bottom: 1rem;
  }

  a:not(.btn) {
    color: $blue-900;
  }

  p:not(:last-child) {
    margin-bottom: 0.5rem;
  }
}
</style>
